import New from '@admin/components/mjson_designer/entities/page/modals/new'
import ElementToken from '@admin/components/mjson_designer/tokens/element'
import ModalPanel from '@admin/components/modal_panel'
import Search from '@admin/components/search'
import PropTypes from 'prop-types'
import React from 'react'

class Modals extends React.PureComponent {

  static contextTypes = {
    modal: PropTypes.object
  }

  static propTypes = {
    device: PropTypes.object,
    website: PropTypes.object,
    onBack: PropTypes.func,
    onNavigate: PropTypes.func,
    onSettings: PropTypes.func
  }

  _handleChoose = this._handleChoose.bind(this)
  _handleNew = this._handleNew.bind(this)

  render() {
    return (
      <ModalPanel { ...this._getPanel() }>
        <Search { ...this._getSearch() } />
      </ModalPanel>
    )
  }

  _getPanel() {
    return {
      showHeader: false,
      buttons: [
        { label: 'Create New Modal', color: 'blue', handler: this._handleNew }
      ]
    }
  }

  _getProps() {
    const { website } = this.props
    return {
      website,
      onDone: this._handleChoose
    }
  }

  _getSearch() {
    const { website } = this.props
    return {
      endpoint: `/api/admin/websites/websites/${website.id}/modals`,
      format: (modal) => <ElementToken icon="window-maximize" type="modal" element={ modal } />,
      label: 'Modal',
      valueKey: null,
      textKey: 'title',
      onChange: this._handleChoose
    }
  }

  _handleChoose(modal) {
    this.props.onSettings(null)
    this.props.onNavigate(`/websites_modals/${modal.id}`)
  }

  _handleNew() {
    this.context.modal.open(<New { ...this._getProps() } />)
  }

}

export default Modals
